import type { MagnusUIMessage } from "@magnus/contract/messages";

/**
 * The run to reattach to. The server's unspent snapshot wins: a session
 * marker can outlive its run (a turn that finished while the tab was away),
 * while the snapshot describes the chat as it is now. `||` not `??`: an empty
 * string from a stale payload means "no run id".
 */
export function resumableRunId(
  serverRunId: string | null | undefined,
  sessionRunId: string | null | undefined
): string | null {
  return serverRunId || sessionRunId || null;
}

/** A persisted compaction checkpoint is still part of an active response. */
export function hasCompletedInitialTurn(
  messages: readonly MagnusUIMessage[],
  activeRunId?: string
): boolean {
  const last = messages.at(-1);
  if (last?.role !== "assistant") {
    return false;
  }
  if (!activeRunId) {
    return true;
  }
  return (
    last.metadata?.runId === activeRunId &&
    last.metadata?.finishReason !== "compaction" &&
    (last.metadata?.status === "success" || last.metadata?.status === "error")
  );
}
